import React from "react";
import Loader from "../components/loader";
import { _ } from "libs";

const Shop = () => {
	return (
		<div className="shopPage" style={{ position: "absolute", top: "64px", bottom: 0, left: 0, right: 0 }}>
            <iframe src="https://www.tennisfactory.ch/" width="100%" style={{ border: "none", height: "100%", position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }}></iframe>
		</div>
	);
};

export default Shop;